(function () {
  'use strict';

  var config = window.PG_ABTESTS || {};
  var experiments = Array.isArray(config.experiments) ? config.experiments : [];
  var endpoint = config.event_endpoint || '';
  var cookieDays = Number(config.cookie_days || 30);
  var BEDBUG_DESC_EXPERIMENT_ID = 'pg_bedbug_b2_desc_001';
  var BEDBUG_GOOGLE_PLUGIN_EXPERIMENT_ID = 'pg_bedbug_google_plugin_style_001';
  var BEDBUG_GOOGLE_PLUGIN_TARGET_PATH = '/products/pest-guard%E2%84%A2-2025-upgraded-bed-bug-killer-pest-repeller';
  var PRODUCT4_EXPERIMENT_ID = 'pg_product4_lp_aa_001';
  var PRODUCT4_C_VIEW_SUFFIX = 'pg-restored-default-abcache-20260628-b2c-7030';
  var PLUGIN_PRODUCT_TARGET_PATH = '/products/plug-in-pest-repeller-for-home-bed-bug-repellent';
  var PLUGIN_DESCRIPTION_IMAGE_REPAIRS = {
    'https://image.zenerve.store/generated/1764255701926-scxxg8yucbl.jpeg': 'https://cdn.shopify.com/s/files/1/0957/5835/2748/files/pestguard-description-hero-restored-2026-07-29.jpg?v=1785345931',
    'https://image.zenerve.store/generated/1764263063400-0jy7wpuyauso.jpeg': 'https://cdn.shopify.com/s/files/1/0957/5835/2748/files/1764254183131-ctv1x12m6se.jpg?v=1764255214',
    'https://image.zenerve.store/generated/1764262486662-pskx7gyczch.jpeg': 'https://cdn.shopify.com/s/files/1/0957/5835/2748/files/1764254827681-zacp3q5ncfa.jpg?v=1764255214',
    'https://image.zenerve.store/generated/1764262711677-9ex9w3m2f7h.jpeg': 'https://cdn.shopify.com/s/files/1/0957/5835/2748/files/1764254927520-6bhimqo8bb8.jpg?v=1764255214'
  };

  if (!experiments.some(function (experiment) {
    return experiment && experiment.id === BEDBUG_GOOGLE_PLUGIN_EXPERIMENT_ID;
  })) {
    experiments.push({
      id: BEDBUG_GOOGLE_PLUGIN_EXPERIMENT_ID,
      status: 'active',
      target_paths: [BEDBUG_GOOGLE_PLUGIN_TARGET_PATH],
      split: { A: 100 },
      variants: {
        A: {
          label: 'current_bedbug_control',
          description: 'Current live high-traffic Bed Bug Killer product page.'
        },
        B: {
          label: 'google_plugin_style_description',
          description: 'Preserves native Product Liquid purchase path and inserts a 2026 Plug-In-style Google-intent description focused on bed bug room-by-room use.'
        }
      },
      force_variant: '',
      c2_redirect_path: '',
      channel_routing: {
        google: {
          split: { A: 100 },
          source: 'gclid_or_utm_source_google',
          reason: 'B was stopped; JS fallback routes cached Bed Bug Google traffic back to A.'
        }
      },
      allow_query_override: true
    });
  }

  experiments.forEach(function (experiment) {
    if (!experiment || experiment.id !== BEDBUG_GOOGLE_PLUGIN_EXPERIMENT_ID) return;
    experiment.split = { A: 100 };
    experiment.force_variant = '';
    experiment.c2_redirect_path = '';
    experiment.channel_routing = experiment.channel_routing || {};
    experiment.channel_routing.google = experiment.channel_routing.google || {};
    experiment.channel_routing.google.split = { A: 100 };
    experiment.channel_routing.google.force_variant = '';
    experiment.channel_routing.google.reason = 'B stopped after underperforming; keep Google traffic on A.';
  });

  experiments.forEach(function (experiment) {
    if (!experiment || experiment.id !== PRODUCT4_EXPERIMENT_ID) return;
    var split = experiment.split || {};
    var isStaleA50B250 = Number(split.A) === 50 && Number(split.B2) === 50 && !Object.prototype.hasOwnProperty.call(split, 'C');
    if (isStaleA50B250) {
      experiment.split = { C: 100 };
      experiment.allow_query_override = true;
    } else if (Number(split.C) > 0 && Number(split.C2) > 0 && !Object.prototype.hasOwnProperty.call(split, 'B2')) {
      experiment.split = { C: 100 };
      experiment.c2_redirect_path = '';
      experiment.allow_query_override = true;
    } else if (Number(split.B2) > 0 && Number(split.C) > 0 && !Object.prototype.hasOwnProperty.call(split, 'C2')) {
      experiment.split = { C: 100 };
      experiment.c2_redirect_path = '';
      experiment.allow_query_override = true;
    }
    if (!experiment.channel_routing || typeof experiment.channel_routing !== 'object') {
      experiment.channel_routing = {
        google: { split: { C: 100 } },
        meta: { split: { A: 50, C: 50 } }
      };
    } else {
      experiment.channel_routing.google = experiment.channel_routing.google || {};
      experiment.channel_routing.google.split = { C: 100 };
      experiment.channel_routing.google.force_variant = '';
      experiment.channel_routing.google.reason = 'C full rollout after leading Google A on conversion rate and revenue per session.';
      experiment.channel_routing.meta = experiment.channel_routing.meta || {};
      experiment.channel_routing.meta.split = { A: 50, C: 50 };
      experiment.channel_routing.meta.force_variant = '';
      experiment.channel_routing.meta.reason = 'Concurrent Meta A/C 50/50 test after C full-rollout performance weakened.';
    }
    experiment.assignment_version = 'meta-ac-20260718';
  });

  function normalizePath(path) {
    return String(path || '').replace(/\/+$/, '').toLowerCase() || '/';
  }

  function repairPluginDescriptionImages() {
    if (normalizePath(window.location.pathname) !== normalizePath(PLUGIN_PRODUCT_TARGET_PATH)) return;
    document.querySelectorAll('img').forEach(function (img) {
      ['src', 'data-pg-defer-src'].forEach(function (attribute) {
        var current = img.getAttribute(attribute) || '';
        var replacement = PLUGIN_DESCRIPTION_IMAGE_REPAIRS[current];
        if (!replacement) return;
        img.setAttribute(attribute, replacement);
        if (attribute === 'src') img.removeAttribute('srcset');
        img.setAttribute('data-pg-description-image-repaired', 'true');
      });
    });
  }

  function readCookie(name) {
    var prefix = name + '=';
    return document.cookie.split(';').map(function (part) {
      return part.trim();
    }).filter(function (part) {
      return part.indexOf(prefix) === 0;
    }).map(function (part) {
      return decodeURIComponent(part.slice(prefix.length));
    })[0] || '';
  }

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax; Secure';
  }

  function visitorId() {
    var name = 'pg_ab_vid';
    var id = readCookie(name);
    if (id) return id;
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      id = window.crypto.randomUUID();
    } else {
      id = 'v-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }
    writeCookie(name, id, 365);
    return id;
  }

  function hashString(value) {
    var hash = 2166136261;
    var input = String(value || '');
    for (var i = 0; i < input.length; i += 1) {
      hash ^= input.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function chooseVariantFromSplit(experiment, id, split) {
    split = split || { A: 50, B: 50 };
    var entries = Object.keys(split).map(function (variant) {
      return [variant, Number(split[variant])];
    }).filter(function (entry) {
      return Number.isFinite(entry[1]) && entry[1] > 0;
    });
    var total = entries.reduce(function (sum, entry) {
      return sum + entry[1];
    }, 0);
    if (!entries.length || total <= 0) return 'A';
    var bucket = hashString(experiment.id + '|' + id) % total;
    var cursor = 0;
    for (var i = 0; i < entries.length; i += 1) {
      cursor += entries[i][1];
      if (bucket < cursor) return entries[i][0];
    }
    return entries[entries.length - 1][0];
  }

  function chooseVariant(experiment, id) {
    return chooseVariantFromSplit(experiment, id, experiment.split);
  }

  function splitHasVariant(experiment, value) {
    return Boolean(experiment.split && Object.prototype.hasOwnProperty.call(experiment.split, value));
  }

  function splitVariantWeight(experiment, value) {
    return splitHasVariant(experiment, value) ? Number(experiment.split[value]) || 0 : 0;
  }

  function product4KnownVariant(experiment, value) {
    return Boolean(
      experiment &&
      experiment.id === PRODUCT4_EXPERIMENT_ID &&
      ['A', 'B', 'B2', 'C', 'C2'].indexOf(String(value || '').toUpperCase()) !== -1
    );
  }

  function experimentHasVariant(experiment, value) {
    return Boolean(
      splitHasVariant(experiment, value) ||
      (experiment.variants && Object.prototype.hasOwnProperty.call(experiment.variants, value)) ||
      product4KnownVariant(experiment, value)
    );
  }

  function isProduct4CStyleVariant(hit) {
    return Boolean(hit && hit.experiment_id === PRODUCT4_EXPERIMENT_ID && (hit.variant === 'C' || hit.variant === 'C2'));
  }

  function normalizeVariantKey(experiment, value) {
    var raw = String(value || '');
    if (!raw) return '';
    if (experimentHasVariant(experiment, raw)) return raw;
    var upper = raw.toUpperCase();
    return experimentHasVariant(experiment, upper) ? upper : '';
  }

  function matchingExperiment() {
    var path = normalizePath(window.location.pathname);
    var requestedId = new URLSearchParams(window.location.search).get('pg_ab_experiment') || '';
    var requested = experiments.find(function (experiment) {
      return experiment.status === 'active' && experiment.id === requestedId && experimentMatchesPath(experiment, path) && experimentEligible(experiment);
    });
    if (requested) return requested;
    return experiments.find(function (experiment) {
      if (experiment.status !== 'active') return false;
      return experimentMatchesPath(experiment, path) && experimentEligible(experiment);
    }) || null;
  }

  function experimentPaths(experiment) {
    var routes = experiment.variant_routes && typeof experiment.variant_routes === 'object'
      ? Object.keys(experiment.variant_routes).map(function (variant) { return experiment.variant_routes[variant]; })
      : [];
    return (experiment.target_paths || []).concat(routes).filter(Boolean).map(normalizePath);
  }

  function experimentMatchesPath(experiment, path) {
    return experimentPaths(experiment).indexOf(normalizePath(path)) !== -1;
  }

  function assignmentCookieName(experiment) {
    var assignmentVersion = String(experiment.assignment_version || '').replace(/[^a-z0-9_-]+/gi, '_');
    return 'pg_ab_' + experiment.id + (assignmentVersion ? '_' + assignmentVersion : '');
  }

  function experimentEligible(experiment) {
    var eligible = Array.isArray(experiment.eligible_channels) ? experiment.eligible_channels : [];
    if (!eligible.length) return true;
    var requestedId = new URLSearchParams(window.location.search).get('pg_ab_experiment') || '';
    if (requestedId === experiment.id) return true;
    var channel = trafficChannel();
    if (channel && eligible.indexOf(channel) !== -1) return true;
    return Boolean(readCookie(assignmentCookieName(experiment)));
  }

  function savedExperiment() {
    var path = normalizePath(window.location.pathname);
    var requestedId = new URLSearchParams(window.location.search).get('pg_ab_experiment') || '';
    var requested = experiments.find(function (experiment) {
      if (experiment.status !== 'active' || experiment.id !== requestedId) return false;
      return Boolean(readCookie(assignmentCookieName(experiment)));
    });
    if (requested) return requested;
    var pathMatch = experiments.find(function (experiment) {
      if (experiment.status !== 'active' || !experimentMatchesPath(experiment, path)) return false;
      return Boolean(readCookie(assignmentCookieName(experiment)));
    });
    if (pathMatch) return pathMatch;
    return experiments.find(function (experiment) {
      if (experiment.status !== 'active') return false;
      return Boolean(readCookie(assignmentCookieName(experiment)));
    }) || null;
  }

  function queryVariant(experiment) {
    if (!experiment.allow_query_override) return '';
    var value = new URLSearchParams(window.location.search).get('pg_ab_variant') || '';
    return normalizeVariantKey(experiment, value);
  }

  function forcedVariant(experiment) {
    var value = String(experiment.force_variant || '').toUpperCase();
    return normalizeVariantKey(experiment, value);
  }

  function utmPayload() {
    var params = new URLSearchParams(window.location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
    return keys.reduce(function (out, key) {
      out[key] = params.get(key) || '';
      return out;
    }, {});
  }

  function trafficChannel() {
    var payload = utmPayload();
    var source = String(payload.utm_source || '').toLowerCase();
    if (payload.gclid || source === 'google' || source === 'googleads' || source === 'google_ads') return 'google';
    if (payload.fbclid || ['meta', 'facebook', 'fb', 'instagram', 'ig'].indexOf(source) !== -1) return 'meta';
    return '';
  }

  function channelForcedVariant(experiment) {
    var routes = experiment.channel_routing || {};
    var route = routes[trafficChannel()] || null;
    if (!route || !route.force_variant) return '';
    return normalizeVariantKey(experiment, route.force_variant);
  }

  function channelSplit(experiment) {
    var routes = experiment.channel_routing || {};
    var route = routes[trafficChannel()] || null;
    if (!route || !route.split || typeof route.split !== 'object') return null;
    return route.split;
  }

  function activeSplit(experiment) {
    return channelSplit(experiment) || experiment.split || {};
  }

  function activeSplitVariantWeight(experiment, value) {
    var split = activeSplit(experiment);
    return Object.prototype.hasOwnProperty.call(split, value) ? Number(split[value]) || 0 : 0;
  }

  function assignment(experiment, options) {
    var canCreate = !options || options.canCreate !== false;
    var id = visitorId();
    var cookieName = assignmentCookieName(experiment);
    var saved = normalizeVariantKey(experiment, readCookie(cookieName));
    if (saved && activeSplitVariantWeight(experiment, saved) <= 0) saved = '';
    if (!saved && !canCreate) return null;
    var previewVariant = canCreate ? queryVariant(experiment) : '';
    var routeVariant = canCreate ? channelForcedVariant(experiment) : '';
    var variant = previewVariant || forcedVariant(experiment) || routeVariant || saved || chooseVariantFromSplit(experiment, id, activeSplit(experiment));
    writeCookie(cookieName, variant, cookieDays);
    return {
      experiment_id: experiment.id,
      variant: variant,
      visitor_id: id,
      assignment_id: experiment.id + ':' + id,
      assigned_at: new Date().toISOString()
    };
  }

  function hydrateDeferredVariantImages(node) {
    node.querySelectorAll('img[data-pg-defer-src]').forEach(function (img) {
      var src = img.getAttribute('data-pg-defer-src');
      if (!src) return;
      img.setAttribute('src', src);
      img.removeAttribute('data-pg-defer-src');
    });
  }

  function applyVisibility(hit) {
    document.documentElement.removeAttribute('data-pg-ab-variant');
    document.querySelectorAll('[data-pg-ab-experiment][data-pg-ab-variant-only]').forEach(function (node) {
      if (node.getAttribute('data-pg-ab-experiment') === hit.experiment_id) {
        node.hidden = true;
      }
    });
    document.documentElement.setAttribute('data-pg-ab-test', hit.experiment_id);
    document.documentElement.setAttribute('data-pg-ab-variant', hit.variant);
    document.querySelectorAll('[data-pg-ab-experiment][data-pg-ab-variant-only]').forEach(function (node) {
      var sameExperiment = node.getAttribute('data-pg-ab-experiment') === hit.experiment_id;
      if (!sameExperiment) return;
      var sameVariant = node.getAttribute('data-pg-ab-variant-only') === hit.variant;
      node.hidden = !sameVariant;
      if (sameVariant) hydrateDeferredVariantImages(node);
    });
  }

  function assetUrl(file) {
    var script = document.currentScript;
    if (!script || !script.src) {
      var scripts = document.querySelectorAll('script[src*="pg-abtest-v"]');
      script = scripts[scripts.length - 1] || null;
    }
    if (script && script.src) {
      return script.src.replace(/pg-abtest-v[0-9]+\.js(?:\?.*)?$/u, file);
    }
    return '/cdn/shop/t/1/assets/' + file;
  }

  function ensureBPageFallbackStyles() {
    if (document.getElementById('pgb-fallback-styles')) return;
    var style = document.createElement('style');
    style.id = 'pgb-fallback-styles';
    style.textContent = [
      '.pgb-product-gallery{display:grid;gap:12px;margin:0 0 18px}',
      '.pgb-gallery-main{border:1px solid #d6e4f4;background:#f6f9fc;overflow:hidden}',
      '.pgb-gallery-main img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover}',
      '.pgb-gallery-strip{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}',
      '.pgb-gallery-strip img{width:100%;aspect-ratio:1/1;object-fit:cover;border:1px solid #d6e4f4;background:#fff}',
      '[data-pg-ab-experiment][data-pg-ab-variant-only][hidden]{display:none!important}',
      'html[data-pg-ab-variant="B"] rte-formatter.text-block[class*="__text_aEtTtq"],html[data-pg-ab-variant="B"] .text-block[class*="__text_aEtTtq"],html[data-pg-ab-variant="B2"] rte-formatter.text-block[class*="__text_aEtTtq"],html[data-pg-ab-variant="B2"] .text-block[class*="__text_aEtTtq"],html[data-pg-ab-variant="C"] rte-formatter.text-block[class*="__text_aEtTtq"],html[data-pg-ab-variant="C"] .text-block[class*="__text_aEtTtq"]{display:none!important}',
      '.pgb-desc{--pgb-ink:#101828;--pgb-muted:#667085;--pgb-line:#d6e4f4;--pgb-blue:#1263d8;--pgb-navy:#071a3a;color:var(--pgb-ink);font-family:var(--font-body--family,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif)}',
      '.pgb-desc-band{max-width:1180px;margin:0 auto;padding:46px 18px;border-top:1px solid var(--pgb-line);display:grid;grid-template-columns:minmax(0,1fr);gap:24px;align-items:center}',
      '.pgb-desc-band:nth-child(odd){background:#f7fbff}',
      '.pgb-desc h2{margin:8px 0 12px;font-size:clamp(28px,4vw,44px);line-height:1.05;letter-spacing:0;color:var(--pgb-navy)}',
      '.pgb-desc p{margin:0;color:var(--pgb-muted);line-height:1.6;font-size:16px}',
      '.pgb-kicker{display:inline-flex;padding:6px 10px;border:1px solid rgba(18,99,216,.22);color:var(--pgb-blue);font-size:12px;font-weight:900;text-transform:uppercase;background:#fff}',
      '.pgb-signal-row,.pgb-coverage-grid,.pgb-step-grid,.pgb-room-list,.pgb-review-grid,.pgb-faq-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin-top:18px}',
      '.pgb-signal-row>div,.pgb-coverage-grid article,.pgb-step-grid article,.pgb-room-list>div,.pgb-review-grid article,.pgb-faq-grid details{background:#fff;border:1px solid var(--pgb-line);padding:16px}',
      '.pgb-desc strong{display:block;margin-bottom:6px;color:var(--pgb-navy)}',
      '.pgb-review-grid span{display:block;color:#f59e0b;font-weight:900;margin-bottom:6px}',
      '.pgb-desc-media img{display:block;width:100%;border:1px solid var(--pgb-line);background:#fff}',
      '@media(min-width:860px){.pgb-desc-band{grid-template-columns:1.05fr .95fr}.pgb-problem{display:block}.pgb-proof{grid-template-columns:1fr .8fr}}',
      '@media(max-width:720px){.pgb-gallery-strip,.pgb-signal-row,.pgb-coverage-grid,.pgb-step-grid,.pgb-room-list,.pgb-review-grid,.pgb-faq-grid{grid-template-columns:1fr}.pgb-desc-band{padding:38px 16px}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function hideOriginalDescriptionForB() {
    document.querySelectorAll('rte-formatter.text-block[class*="__text_aEtTtq"], .text-block[class*="__text_aEtTtq"]').forEach(function (node) {
      node.hidden = true;
      node.setAttribute('data-pg-ab-hidden-original', 'true');
      node.setAttribute('data-pg-ab-fallback-hidden-description', 'true');
    });
  }

  function bGalleryHtml() {
    var main = assetUrl('01-main-offer-direct-image2.png');
    var room = assetUrl('02-room-plan-direct-image2.png');
    var tech = assetUrl('03-trust-guarantee-direct-image2.png');
    var proof = assetUrl('04-review-proof-direct-image2.png');
    return [
      '<div class="pgb-product-gallery pgb-js-fallback" aria-label="PestGuard product offer media">',
      '<div class="pgb-gallery-main"><img src="' + main + '" alt="PestGuard Buy 3 Get 3 Free whole-home pest plan" loading="eager"></div>',
      '<div class="pgb-gallery-strip">',
      '<img src="' + main + '" alt="PestGuard Buy 3 Get 3 Free offer image" loading="eager">',
      '<img src="' + room + '" alt="PestGuard bedroom kitchen storage room coverage plan" loading="lazy">',
      '<img src="' + tech + '" alt="PestGuard Dual-Wave ultrasonic coverage image" loading="lazy">',
      '<img src="' + proof + '" alt="PestGuard verified buyer and guarantee proof image" loading="lazy">',
      '</div></div>'
    ].join('');
  }

  function bDescriptionHtml() {
    var main = assetUrl('01-main-offer-direct-image2.png');
    var room = assetUrl('02-room-plan-direct-image2.png');
    var tech = assetUrl('03-trust-guarantee-direct-image2.png');
    var proof = assetUrl('04-review-proof-direct-image2.png');
    return [
      '<div class="pgb-desc pgb-js-fallback">',
      '<section class="pgb-desc-band pgb-result"><div class="pgb-copy"><span class="pgb-kicker">No more pests or it is free</span><h2>A cleaner way to make your home feel protected again.</h2><p>PestGuard is built for people who do not want sprays, trap cleanup, or a home that feels uncomfortable at night. Plug it in, leave it running, and support the rooms where pests are most likely to move, hide, and return.</p><div class="pgb-signal-row"><div><strong>18,000+ homes</strong><p>Used room by room by people who want a lower-maintenance setup.</p></div><div><strong>90-day guarantee</strong><p>If it is not the right fit, the purchase is backed by the existing money-back policy.</p></div><div><strong>No chemical routine</strong><p>No spray smell, poison residue, or daily trap cleanup around the home.</p></div></div></div><div class="pgb-desc-media"><img src="' + main + '" alt="PestGuard Buy 3 Get 3 Free whole-home pest plan" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-problem"><div class="pgb-copy"><span class="pgb-kicker">Hidden-route problem</span><h2>Seeing one pest usually means the route is already active.</h2><p>Sprays and traps focus on what you can see. PestGuard supports the environment pests move through, including baseboards, cabinets, outlets, shared walls, and quiet storage areas.</p><div class="pgb-coverage-grid"><article><strong>Visible signs are only the surface</strong><p>The stressful part is usually the repeat path behind the room.</p></article><article><strong>Walls and furniture matter</strong><p>Closed doors, corners, and room layout reduce practical coverage from a single device.</p></article><article><strong>The goal is continuous pressure</strong><p>Keep the room supported every day instead of reacting only when activity appears.</p></article></div></div></section>',
      '<section class="pgb-desc-band pgb-mechanism"><div class="pgb-copy"><span class="pgb-kicker">Dual-Wave technology</span><h2>Plug it in once. Let ultrasonic support run every day.</h2><p>PestGuard emits Dual-Wave ultrasonic pulses designed to make common hiding routes behind walls, baseboards, outlets, and cabinets less comfortable for pests over time.</p><div class="pgb-step-grid"><article><strong>1. Plug into an open outlet</strong><p>Place one device in each target room or zone.</p></article><article><strong>2. Leave it running 24/7</strong><p>No refills, chemical smell, trap cleanup, or daily routine.</p></article><article><strong>3. Give the room time</strong><p>Use it consistently while reducing food sources, clutter, and entry gaps.</p></article></div></div><div class="pgb-desc-media"><img src="' + tech + '" alt="PestGuard Dual-Wave ultrasonic technology image" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-coverage"><div class="pgb-copy"><span class="pgb-kicker">Coverage plan</span><h2>One device can help one zone. A bundle gives you a plan.</h2><p>Most homes need coverage in more than one place. The Buy 3 Get 3 Free offer works as a room plan, not just extra devices.</p><div class="pgb-room-list"><div><strong>Bedroom</strong><p>Support the room where nighttime activity feels most stressful.</p></div><div><strong>Kitchen</strong><p>Cover pantry routes, cabinets, baseboards, and walls pests travel behind.</p></div><div><strong>Storage areas</strong><p>Add coverage for closets, laundry rooms, basements, garages, luggage, and seasonal boxes.</p></div></div></div><div class="pgb-desc-media"><img src="' + room + '" alt="PestGuard whole-home room coverage illustration" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-proof"><div class="pgb-copy"><span class="pgb-kicker">Social proof</span><h2>A simple routine that feels cleaner than sprays and traps.</h2><div class="pgb-review-grid"><article><span>Easy setup</span><strong>Plug in and leave it on</strong><p>Place one device in each target room, keep the outlet open, and let it run in the background.</p></article><article><span>Cleaner home routine</span><strong>No spraying around beds or food areas</strong><p>Helpful for homes that need pest support without chemical smell or visible trap cleanup.</p></article><article><span>Bundle logic</span><strong>Cover more than one problem area</strong><p>Use multiple devices to support bedrooms, kitchens, storage areas, and shared walls at the same time.</p></article></div></div><div class="pgb-desc-media"><img src="' + proof + '" alt="PestGuard verified buyer and homes proof" loading="lazy"></div></section>',
      '<section class="pgb-desc-band"><div class="pgb-copy"><span class="pgb-kicker">Lower-risk setup</span><h2>No sprays. No trap cleanup. Backed by a 90-day guarantee.</h2><p>PestGuard fits into a cleaner routine: reduce food sources, seal gaps, reduce clutter, and monitor high-activity areas.</p><div class="pgb-faq-grid"><details open><summary>Does one device cover the whole home?</summary><p>No. Use one device per target room or zone because walls and furniture reduce practical coverage.</p></details><details><summary>What makes it different from sprays or traps?</summary><p>Sprays and traps react to visible pests. PestGuard is a continuous plug-in repeller for the room.</p></details><details><summary>What makes the purchase lower risk?</summary><p>The order is backed by the same 90-day money-back guarantee already used on the current page.</p></details></div></div></section>',
      '</div>'
    ].join('');
  }

  function bedBugDescriptionHtml() {
    return bedBugDescriptionHtmlV2();
  }

  function hideBedBugTemplateModulesForB() {
    document.querySelectorAll('main.pg-page, .pg-page').forEach(function (node) {
      if (closestMatch(node, '.pgb-bedbug-desc-only')) return;
      var section = closestMatch(node, '.shopify-section') || node;
      section.hidden = true;
      section.setAttribute('data-pg-ab-bedbug-hidden-template', 'true');
    });
  }

  function bedBugProductGalleryHtml() {
    return [
      '<div class="pgb-bedbug-product-gallery" data-pg-ab-generated="bedbug-product-liquid-gallery">',
      '<style>',
      '.pgb-bedbug-product-gallery{display:grid;gap:10px;margin:0 0 16px;width:100%;max-width:680px}',
      '.pgb-bedbug-gallery-main{border:1px solid #dbe7f5;border-radius:10px;background:#fff;overflow:hidden;box-shadow:0 14px 34px rgba(16,24,40,.08)}',
      '.pgb-bedbug-gallery-main img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover}',
      '.pgb-bedbug-gallery-strip{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px}',
      '.pgb-bedbug-gallery-strip img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover;border:1px solid #dbe7f5;border-radius:8px;background:#fff}',
      '.product-information__media.pgb-bedbug-gallery-ready{display:block!important;min-height:360px!important}',
      '.product-information__media.pgb-bedbug-gallery-ready [data-pg-bedbug-gallery-hidden="true"]{display:none!important}',
      '@media(max-width:749px){.pgb-bedbug-product-gallery{max-width:none;margin-bottom:18px}.pgb-bedbug-gallery-strip{gap:6px}}',
      '</style>',
      '<div class="pgb-bedbug-gallery-main"><img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/hero-bedbug-hide-here-image2.png?v=1781448959&width=1600" alt="PestGuard bed bug product main image" loading="eager"></div>',
      '<div class="pgb-bedbug-gallery-strip" aria-label="PestGuard bed bug product images">',
      '<img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/hero-bedbug-hide-here-image2.png?v=1781448959&width=600" alt="PestGuard bed bug product box" loading="eager">',
      '<img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/1764061305879_0f500704-fd00-4fce-9bc5-61bd34bd1660.png?v=1781448961&width=600" alt="PestGuard plugged into bedroom outlet" loading="lazy">',
      '<img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/1764061430274_e7f7e93c-b8a5-4f2c-a374-5e4b0309a9be.png?v=1781448963&width=600" alt="PestGuard Dual-Wave bed bug support diagram" loading="lazy">',
      '<img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/1764061560212_fe0e61c8-1111-4ab6-b089-c05ccc29d6d0.png?v=1781448964&width=600" alt="PestGuard device size in hand" loading="lazy">',
      '<img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/1764061942707_2a8f676c-e8c1-48e5-b2d3-fa97a74b6d84.png?v=1781448966&width=600" alt="PestGuard device indicator light" loading="lazy">',
      '</div>',
      '</div>'
    ].join('');
  }

  function installBedBugProductGalleryForB() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;
    media.classList.add('pgb-bedbug-gallery-ready');
    Array.prototype.forEach.call(media.children, function (node) {
      if (node.classList && node.classList.contains('pgb-bedbug-product-gallery')) return;
      node.hidden = true;
      node.setAttribute('data-pg-bedbug-gallery-hidden', 'true');
    });
    var existing = media.querySelector('.pgb-bedbug-product-gallery');
    if (existing) {
      existing.outerHTML = bedBugProductGalleryHtml();
    } else {
      media.insertAdjacentHTML('afterbegin', bedBugProductGalleryHtml());
    }
  }

  function bedBugDescriptionHtmlV2() {
    return [
      '<div class="pgb-bedbug-desc-only pgb-js-fallback" data-pg-ab-generated="bedbug-pgwrap-description-only-v2">',
      '<style>',
      '.pg-wrap{--pg-primary:#1a6cff;--pg-primary-soft:#e6f0ff;--pg-accent:#00b4a0;--pg-bg:#f4f7ff;--pg-text-main:#111827;--pg-text-muted:#5f6b7a;--pg-max-width:1120px;font-family:system-ui,-apple-system,BlinkMacSystemFont,"Inter","Poppins",sans-serif;color:var(--pg-text-main);background:#fff}',
      '.pg-section{max-width:var(--pg-max-width);margin:0 auto;padding:30px 16px}',
      '.pg-hero{display:grid;gap:16px;background:linear-gradient(135deg,#f7fbff,#eaf3ff);border:1px solid #dbe7f5;border-radius:18px;box-shadow:0 14px 40px rgba(15,23,42,.08);padding:22px 18px}',
      '.pg-badge-row,.pg-hero-cta-row,.pg-cta-row,.pg-guarantee-badges{display:flex;flex-wrap:wrap;gap:10px;align-items:center}',
      '.pg-badge,.pg-badge-secondary,.pg-trust-chip,.pg-guarantee-pill,.pg-guarantee-highlight{display:inline-flex;align-items:center;gap:7px;border-radius:999px;padding:6px 10px;font-size:12px;font-weight:750;line-height:1.2}',
      '.pg-badge{background:#111827;color:#fff}.pg-badge-secondary,.pg-trust-chip{background:rgba(26,108,255,.08);color:#0f55c8}.pg-guarantee-pill{background:#f9fafb;border:1px solid #e5e7eb}.pg-guarantee-highlight{background:#ecfdf3;color:#166534;margin-top:10px}',
      '.pg-hero-title{font-size:clamp(27px,4vw,44px);line-height:1.08;font-weight:850;letter-spacing:0;margin:2px 0}.pg-highlight{color:var(--pg-primary)}',
      '.pg-hero-sub,.pg-section-sub,.pg-card p,.pg-step-body-text,.pg-guarantee-card-text{font-size:14px;line-height:1.58;color:var(--pg-text-muted);margin:0}.pg-hero-sub b,.pg-section-sub b{color:#111827}',
      '.pg-btn-primary,.pg-cta-secondary{display:inline-flex;align-items:center;justify-content:center;gap:8px;border-radius:999px;text-decoration:none;cursor:pointer;border:0;min-height:44px}.pg-btn-primary{padding:12px 20px;background:linear-gradient(135deg,#1d4ed8,#2563eb);color:#fff;font-weight:800;box-shadow:0 12px 28px rgba(37,99,235,.28)}.pg-cta-secondary{padding:10px 14px;background:#fff;color:#0f55c8;border:1px solid rgba(26,108,255,.25);font-weight:750}',
      '.pg-hero-note,.pg-cta-inline-note{font-size:12px;color:var(--pg-text-muted)}',
      '.pg-social-bar{display:grid;gap:8px;background:#0f172a;color:#e5e7eb;border-radius:16px;padding:12px 14px;font-size:12px}.pg-social-pill{display:inline-flex;align-items:center;gap:6px}',
      '.pg-section-title{font-size:clamp(22px,3vw,34px);line-height:1.12;font-weight:850;letter-spacing:0;margin:0 0 8px}',
      '.pg-grid,.pg-scenes-grid,.pg-ugc-grid,.pg-compare-grid{display:grid;grid-template-columns:1fr;gap:14px;margin-top:18px}',
      '.pg-card,.pg-scenes-item,.pg-ugc-card,.pg-guarantee-card{border:1px solid #dbe7f5;border-radius:14px;background:#fff;padding:12px;box-shadow:0 8px 24px rgba(15,23,42,.05)}',
      '.pg-card strong,.pg-scenes-label,.pg-step-body-title,.pg-ugc-name,.pg-guarantee-card-title,.pg-compare-grid strong{display:block;font-size:15px;line-height:1.25;color:#111827;margin-bottom:5px}',
      '.pg-square-img{width:100%;aspect-ratio:1/1;border-radius:12px;overflow:hidden;background:#eef4ff}.pg-square-img img{display:block;width:100%;height:100%;object-fit:cover}',
      '.pg-how,.pg-guarantee{display:grid;gap:18px}.pg-step-list{display:grid;gap:12px;margin-top:14px}.pg-step{display:flex;gap:10px}.pg-step-badge{width:28px;height:28px;border-radius:999px;background:var(--pg-primary-soft);color:var(--pg-primary);font-weight:850;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0}',
      '.pg-ugc{border-radius:18px;background:#0f172a;color:#e5e7eb;padding:22px 16px}.pg-ugc-title{font-size:22px;font-weight:850}.pg-ugc-sub,.pg-ugc-meta,.pg-ugc-text{color:#cbd5e1;font-size:13px;line-height:1.5}.pg-ugc-card{background:rgba(15,23,42,.94);border-color:rgba(148,163,184,.24)}.pg-ugc-name{color:#fff}.pg-ugc-stars{color:#fbbf24;font-size:13px}',
      '.pg-guarantee-card{background:#0f172a;color:#e5e7eb}.pg-guarantee-card-title{color:#fff}.pg-guarantee-bullets{font-size:13px;line-height:1.55;margin:10px 0 0;padding-left:18px}.pg-guarantee-bullets li{margin-bottom:4px}',
      '.pg-compare-grid article{border:1px solid #dbe7f5;border-radius:12px;background:#f9fbff;padding:13px}.pg-compare-grid p{font-size:13px;color:var(--pg-text-muted);line-height:1.5;margin:6px 0 0}',
      '@media(min-width:760px){.pg-hero{grid-template-columns:1fr}.pg-grid,.pg-scenes-grid,.pg-ugc-grid,.pg-compare-grid{grid-template-columns:repeat(3,minmax(0,1fr))}.pg-how,.pg-guarantee{grid-template-columns:minmax(0,1.1fr) minmax(320px,.8fr);align-items:center}.pg-social-bar{grid-template-columns:repeat(3,minmax(0,1fr));border-radius:999px}}',
      '</style>',
      '<div class="pg-wrap">',
      '<section class="pg-section">',
      '<div class="pg-hero">',
      '<div class="pg-badge-row"><div class="pg-badge">Bed bug bedroom support</div><div class="pg-badge-secondary">For bedrooms, closets, luggage and shared walls</div></div>',
      '<h1 class="pg-hero-title">Support the rooms where <span class="pg-highlight">bed bugs hide</span> without spraying the bed.</h1>',
      '<p class="pg-hero-sub">PestGuard is a plug-in ultrasonic support device for shoppers who want a cleaner step around <b>mattress seams, headboards, bedside outlets, closets, luggage areas and nearby hallways</b>. It is positioned as continuous room support, not an instant extermination claim.</p>',
      '<p class="pg-hero-sub">Use one device per target room or route. The product options above let shoppers choose 1, 3, 6 or 9 units based on the rooms they want to support.</p>',
      '<div class="pg-hero-cta-row"><button class="pg-btn-primary pg-cta">Choose my bed bug pack <span class="pg-arrow">-&gt;</span></button><div class="pg-hero-note"><b>90-day money-back guarantee</b> on the current offer.</div></div>',
      '</div>',
      '</section>',
      '<section class="pg-section" style="padding-top:8px"><div class="pg-social-bar"><div class="pg-social-pill">Rated 4.8 by verified buyers</div><div class="pg-social-pill">Plug in once, support runs 24/7</div><div class="pg-social-pill">No poisons, no residue, no spray smell</div></div></section>',
      '<section class="pg-section">',
      '<h2 class="pg-section-title">Bed bugs are a bedroom problem, but the routes are bigger than the bed.</h2>',
      '<p class="pg-section-sub">The B page should answer the exact fear from bed bug traffic: where they hide, how to cover nearby routes, and why a multi-unit pack makes sense.</p>',
      '<div class="pg-grid">',
      '<article class="pg-card"><div class="pg-square-img"><img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/problem-bedbug-signs-image2.png?v=1781449261" alt="Mattress seams and headboard areas where bed bugs may hide" loading="lazy"></div><strong>Mattress seams and headboards</strong><p>Support the high-anxiety areas around the bed without adding spray smell to bedding.</p><div class="pg-cta-row"><button class="pg-cta pg-cta-secondary">Cover the bedroom -&gt;</button></div></article>',
      '<article class="pg-card"><div class="pg-square-img"><img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/placement-bedroom-plan-image2.png?v=1781449262" alt="Bedroom plan showing outlets, closet, luggage and hallway coverage zones" loading="lazy"></div><strong>Closets, laundry and luggage</strong><p>Travel bags, stored clothes, bedding and laundry baskets create the next logical coverage zones.</p><div class="pg-cta-row"><button class="pg-cta pg-cta-secondary">Cover storage zones -&gt;</button></div></article>',
      '<article class="pg-card"><div class="pg-square-img"><img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/mechanism-dual-wave-image2.png?v=1781449265" alt="Dual-Wave ultrasonic support around outlets and shared walls" loading="lazy"></div><strong>Outlets and shared walls</strong><p>Place devices where rooms connect so support is not limited to only one visible spot.</p><div class="pg-cta-row"><button class="pg-cta pg-cta-secondary">Cover connected routes -&gt;</button></div></article>',
      '</div>',
      '</section>',
      '<section class="pg-section"><div class="pg-how"><div><h2 class="pg-section-title">How the plug-in support plan works.</h2><p class="pg-section-sub">PestGuard adds a continuous, non-chemical support layer while customers clean, reduce clutter, wash bedding, seal gaps and monitor active areas.</p><div class="pg-step-list"><div class="pg-step"><div class="pg-step-badge">1</div><div><div class="pg-step-body-title">Plug one unit into the room or route you want to support.</div><div class="pg-step-body-text">Start with the bedroom, then add closet, hallway, luggage or storage zones.</div></div></div><div class="pg-step"><div class="pg-step-badge">2</div><div><div class="pg-step-body-title">Leave Dual-Wave support running every day.</div><div class="pg-step-body-text">No refills, no odor, no sticky trap cleanup around the bed.</div></div></div><div class="pg-step"><div class="pg-step-badge">3</div><div><div class="pg-step-body-title">Use enough units for the real layout.</div><div class="pg-step-body-text">Walls, doors and furniture split practical coverage, which is why bundles need a room-by-room explanation.</div></div></div></div><div class="pg-cta-row" style="margin-top:14px"><button class="pg-btn-primary pg-cta">Select coverage pack <span class="pg-arrow">-&gt;</span></button></div></div><div class="pg-square-img"><img src="https://cdn.shopify.com/s/files/1/0957/5835/2748/files/proof-guarantee-image2.png?v=1781449264" alt="PestGuard guarantee and room support proof graphic" loading="lazy"></div></div></section>',
      '<section class="pg-section"><div class="pg-ugc"><div><div class="pg-ugc-title">Real buyers wanted a cleaner bedroom routine.</div><div class="pg-ugc-sub">These reviews focus on the same situations this page is built around: bedrooms, closets, hallways, luggage zones and guest rooms.</div></div><div class="pg-ugc-grid"><article class="pg-ugc-card"><div class="pg-ugc-stars">★★★★★</div><div class="pg-ugc-name">Verified buyer - apartment bedroom</div><div class="pg-ugc-meta">3-pack setup</div><p class="pg-ugc-text">"I wanted something I could leave plugged in near the bedroom without spraying around the bed."</p></article><article class="pg-ugc-card"><div class="pg-ugc-stars">★★★★★</div><div class="pg-ugc-name">Verified buyer - family home</div><div class="pg-ugc-meta">6-pack setup</div><p class="pg-ugc-text">"The pack made sense once I planned bedroom, closet, hallway and luggage zones separately."</p></article><article class="pg-ugc-card"><div class="pg-ugc-stars">★★★★★</div><div class="pg-ugc-name">Verified buyer - guest room host</div><div class="pg-ugc-meta">9-pack setup</div><p class="pg-ugc-text">"The guarantee made it easier to try before another expensive service visit."</p></article></div><div class="pg-cta-row" style="margin-top:16px"><button class="pg-btn-primary pg-cta">Try bed bug room support <span class="pg-arrow">-&gt;</span></button><div class="pg-cta-inline-note">Backed by the current 90-day policy.</div></div></div></section>',
      '<section class="pg-section"><h2 class="pg-section-title">Which bed bug support method fits this situation?</h2><div class="pg-compare-grid"><article><strong>Sprays and foggers</strong><p>Can leave smell or residue around bedding and may not reach every hiding route.</p></article><article><strong>Sticky monitors</strong><p>Useful for monitoring, but they only help when activity reaches the trap.</p></article><article><strong>PestGuard plug-in support</strong><p>Runs continuously in target rooms without poison residue, refills or trap cleanup.</p></article></div></section>',
      '<section class="pg-section"><div class="pg-guarantee"><div><h2 class="pg-section-title">Cleaner support without sprays around the bed.</h2><p class="pg-section-sub">This page keeps the promise focused: bedroom support, nearby routes, simple setup and clear expectations. For confirmed heavy infestations, customers should still use professional treatment and cleaning steps.</p><div class="pg-guarantee-badges"><div class="pg-guarantee-pill">Safe around kids and pets when used as directed</div><div class="pg-guarantee-pill">No chemicals, smells or residue</div><div class="pg-guarantee-pill">Standard US outlet plug-in</div><div class="pg-guarantee-pill">Up to 800 sq ft per device</div></div><div class="pg-guarantee-highlight">90-Day Money-Back Guarantee</div></div><div class="pg-guarantee-card"><div class="pg-guarantee-card-title">Bed Bug Pack Options</div><p class="pg-guarantee-card-text">Choose the pack size that matches the rooms you want to support. Exact pricing and availability remain controlled by the product selector above.</p><ul class="pg-guarantee-bullets"><li>1x PestGuard - $34.95 - single-room support</li><li>3x PestGuard - $59.95 - bedroom, closet and hallway support</li><li>6x PestGuard - $119.95 - broader home coverage</li><li>9x PestGuard - $149.95 - larger homes, rentals and guest rooms</li></ul><div class="pg-cta-row"><button class="pg-btn-primary pg-cta">Choose my bed bug pack <span class="pg-arrow">-&gt;</span></button></div></div></div></section>',
      '</div>',
      '</div>'
    ].join('');
  }

  function installBedBugDescriptionCtas() {
    var desc = document.querySelector('.pgb-bedbug-desc-only');
    if (!desc) return;
    var target = document.querySelector('#pg-variant-picker') ||
      document.querySelector('variant-picker') ||
      document.querySelector('.product-information form[action*="/cart/add"]') ||
      document.querySelector('.product-information');
    if (!target) return;
    desc.querySelectorAll('.pg-cta').forEach(function (button) {
      if (button.getAttribute('data-pg-bedbug-cta-bound') === 'true') return;
      button.setAttribute('data-pg-bedbug-cta-bound', 'true');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function installBedBugDescriptionOnly(hit) {
    if (hit.variant !== 'B') return;
    ensureBPageFallbackStyles();
    hideOriginalDescriptionForB();
    hideBedBugTemplateModulesForB();
    installBedBugProductGalleryForB();
    var productInfo = document.querySelector('.product-information');
    var existingDesc = document.querySelector('.pgb-bedbug-desc-only');
    if (existingDesc) {
      existingDesc.outerHTML = bedBugDescriptionHtmlV2();
    } else if (productInfo) {
      productInfo.insertAdjacentHTML('afterend', bedBugDescriptionHtmlV2());
    }
    installBedBugDescriptionCtas();
  }

  function bedBugGooglePluginDescriptionHtml() {
    var room = assetUrl('02-room-plan-direct-image2.png');
    var tech = assetUrl('03-trust-guarantee-direct-image2.png');
    var proof = assetUrl('04-review-proof-direct-image2.png');
    return [
      '<div class="pgb-desc pgb-js-fallback pgb-bedbug-desc-only" data-pg-ab-generated="bedbug-google-plugin-style-v1">',
      '<style>.pg-cta{display:inline-flex;align-items:center;justify-content:center;min-height:46px;margin-top:16px;padding:12px 18px;border-radius:999px;background:#1a6cff;color:#fff;font-weight:900;text-decoration:none;box-shadow:0 12px 26px rgba(26,108,255,.22)}.pgb-note-list{margin:14px 0 0;padding-left:19px;color:#5b667a;line-height:1.58}.pgb-note-list li{margin:5px 0}.pgb-desc .pgb-mini-lead{font-size:17px;color:#334155;line-height:1.58}</style>',
      '<section class="pgb-desc-band pgb-problem"><div class="pgb-copy"><span class="pgb-kicker">Plug-in bed bug support</span><h2>PestGuard is built for the rooms where bed bugs keep coming back.</h2><p class="pgb-mini-lead">This version keeps the buying path simple, then explains the product the way Google shoppers search: what it is, where to use it, why one room needs its own device, and how it fits with a cleaner no-spray routine.</p><ul class="pgb-note-list"><li>Plug-in ultrasonic bed bug repeller for home use.</li><li>Useful for bedrooms, closets, luggage areas, apartments, storage spaces, and shared walls.</li><li>Best used room by room instead of moving one unit around the house.</li><li>No spray residue and no visible trap boards in the room.</li><li>Covered by the same 90-day money-back promise.</li></ul><a class="pg-cta" href="#pg-product-form">Choose my room plan</a></div><div class="pgb-desc-media"><img src="' + room + '" alt="PestGuard room-by-room bed bug coverage plan" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-result"><div class="pgb-copy"><span class="pgb-kicker">Search intent match</span><h2>If you are looking for a bed bug spray, also cover the routes sprays miss.</h2><p>Sprays and foggers focus on surfaces you can reach. Bed bugs can hide around bed frames, baseboards, outlets, furniture gaps, luggage, closets, and shared walls. PestGuard gives the room continuous plug-in support while you keep bedding clean, reduce clutter, and monitor active areas.</p><div class="pgb-coverage-grid"><article><strong>Bedroom first</strong><p>Support the room where bites, anxiety, and repeat activity feel most urgent.</p></article><article><strong>Hidden routes</strong><p>Cover outlet walls, floor edges, closets, luggage areas, and furniture gaps.</p></article><article><strong>Continuous routine</strong><p>Leave the device running day and night instead of reacting only after activity appears.</p></article></div></div></section>',
      '<section class="pgb-desc-band pgb-mechanism"><div class="pgb-copy"><span class="pgb-kicker">How it works</span><h2>Plug it into an open outlet and keep steady ultrasonic support in that room.</h2><p>PestGuard emits ultrasonic pulses designed to make covered areas less comfortable for pests over time. It is not a chemical, poison, fogger, or sticky trap. It is a clean support layer for rooms where bed bug activity or pest routes keep returning.</p><div class="pgb-step-grid"><article><strong>1. Pick the target room</strong><p>Start with bedrooms, closets, luggage storage, or the area where activity is most stressful.</p></article><article><strong>2. Keep it plugged in</strong><p>Run it continuously. Do not unplug and move one unit around every day.</p></article><article><strong>3. Pair with prevention</strong><p>Wash bedding, reduce clutter, seal gaps, and keep monitoring problem areas.</p></article></div></div><div class="pgb-desc-media"><img src="' + tech + '" alt="PestGuard ultrasonic plug-in mechanism" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-coverage"><div class="pgb-copy"><span class="pgb-kicker">Why bundles make sense</span><h2>One device supports one zone. Bed bugs do not respect room boundaries.</h2><p>The most common mistake is buying one plug-in for the whole home. Walls, furniture, doors, and distance reduce practical coverage. A multi-pack lets you support the bedroom and the nearby routes pests use to move, hide, and return.</p><div class="pgb-room-list"><div><strong>1-pack</strong><p>For one small room or one test area only.</p></div><div><strong>6-pack</strong><p>Best for bedrooms, closets, nearby outlets, kitchen routes, and storage areas.</p></div><div><strong>14-pack</strong><p>For larger homes, rentals, basements, garages, and multi-room coverage.</p></div></div><a class="pg-cta" href="#pg-product-form">Select my bundle</a></div><div class="pgb-desc-media"><img src="' + room + '" alt="PestGuard multi-room bundle coverage" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-proof"><div class="pgb-copy"><span class="pgb-kicker">Cleaner than sprays and traps</span><h2>A simple room routine customers can keep running every day.</h2><div class="pgb-review-grid"><article><span>No spray smell</span><strong>Better for bedrooms</strong><p>No chemical odor around bedding, nightstands, closets, or pet areas.</p></article><article><span>No trap cleanup</span><strong>Less visible stress</strong><p>No sticky boards sitting in plain view when guests or family are around.</p></article><article><span>90-day promise</span><strong>Lower-risk trial</strong><p>Try the setup in the rooms that matter most with the same money-back guarantee.</p></article></div></div><div class="pgb-desc-media"><img src="' + proof + '" alt="PestGuard guarantee and buyer proof" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-compare"><div class="pgb-copy"><span class="pgb-kicker">FAQ</span><h2>Clear answers before you choose a pack.</h2><div class="pgb-faq-grid"><details open><summary>Will one device cover my whole home?</summary><p>No. Use one device per target room or zone because walls, doors, and furniture reduce practical coverage.</p></details><details><summary>Is this a replacement for cleaning and prevention?</summary><p>No. Use PestGuard as a continuous support layer while washing bedding, reducing clutter, sealing gaps, and monitoring active areas.</p></details><details><summary>Why does the page recommend the 6-pack?</summary><p>Bed bug concerns usually involve more than one route: bedroom, closet, luggage area, shared wall, hallway, or storage space.</p></details></div></div></section>',
      '</div>'
    ].join('');
  }

  function installBedBugGooglePluginStyle(hit) {
    if (hit.variant !== 'B') return;
    ensureBPageFallbackStyles();
    hideOriginalDescriptionForB();
    hideBedBugTemplateModulesForB();
    ensureProductPurchaseAnchor();
    var productInfo = document.querySelector('.product-information');
    var existingDesc = document.querySelector('.pgb-bedbug-desc-only');
    if (existingDesc) {
      existingDesc.outerHTML = bedBugGooglePluginDescriptionHtml();
    } else if (productInfo) {
      productInfo.insertAdjacentHTML('afterend', bedBugGooglePluginDescriptionHtml());
    }
    installBedBugDescriptionCtas();
  }

  function installBPageFallback(hit) {
    if (hit.experiment_id === BEDBUG_GOOGLE_PLUGIN_EXPERIMENT_ID) {
      if (hit.variant === 'B') installBedBugGooglePluginStyle(hit);
      return;
    }
    if (hit.variant !== 'B') return;
    if (hit.experiment_id === BEDBUG_DESC_EXPERIMENT_ID) {
      installBedBugDescriptionOnly(hit);
      return;
    }
    ensureBPageFallbackStyles();
    hideOriginalDescriptionForB();
    if (document.querySelector('.pgb-product-gallery')) return;
    var media = document.querySelector('.product-information__media');
    var productInfo = document.querySelector('.product-information');
    if (!media || !productInfo) return;
    Array.prototype.forEach.call(media.children, function (node) {
      node.hidden = true;
      node.setAttribute('data-pg-ab-fallback-hidden', 'true');
    });
    media.insertAdjacentHTML('afterbegin', bGalleryHtml());
    if (!document.querySelector('.pgb-desc')) {
      productInfo.insertAdjacentHTML('afterend', bDescriptionHtml());
    }
  }

  function ensureBPageFallbackStyles() {
    if (document.getElementById('pgb-fallback-styles')) return;
    var style = document.createElement('style');
    style.id = 'pgb-fallback-styles';
    style.textContent = [
      '.pgb-product-gallery{display:grid;gap:8px;margin:0}',
      '.pgb-gallery-main,.pgb-gallery-strip img,.pgb-desc-media{border:1px solid #dbe7f5;border-radius:8px;background:#fff;overflow:hidden;box-shadow:0 12px 30px rgba(16,24,40,.06)}',
      '.pgb-gallery-main img,.pgb-desc-media img{display:block;width:100%;aspect-ratio:1/1;object-fit:cover}',
      '.pgb-gallery-strip{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}',
      '.pgb-gallery-strip img{width:100%;aspect-ratio:1/1;object-fit:cover}',
      '.pgb-purchase-context{display:grid;gap:8px;margin:-8px 0 2px}',
      '.pgb-score-row{display:flex;flex-wrap:wrap;gap:6px}',
      '.pgb-score-row span,.pgb-kicker{display:inline-flex;align-items:center;min-height:28px;padding:5px 9px;border:1px solid rgba(26,108,255,.2);border-radius:999px;background:#edf5ff;color:#0f55c8;font-size:12px;font-weight:850;line-height:1.15;letter-spacing:0}',
      '.pgb-offer-box{border:1px solid rgba(26,108,255,.24);border-left:4px solid #1a6cff;border-radius:8px;padding:10px 12px;background:#f4f8ff}',
      '.pgb-offer-box strong{display:block;color:#101828;font-size:14px;line-height:1.28}',
      '.pgb-offer-box span{display:block;margin:5px 0 0;color:#5b667a;font-size:12px;line-height:1.38}',
      '.pgb-desc{color:#101828;font-family:var(--font-body--family,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif)}',
      '.pgb-desc-band{display:grid;grid-template-columns:1fr;gap:18px;padding:38px 0;border-top:1px solid #dbe7f5}',
      '.pgb-desc-band:first-child{border-top:0;padding-top:18px}',
      '.pgb-copy h2{margin:10px 0 10px;font-size:clamp(26px,4vw,42px);line-height:1.08;letter-spacing:0;color:#071a3a}',
      '.pgb-copy p{margin:0;color:#5b667a;font-size:16px;line-height:1.56}',
      '.pgb-step-grid,.pgb-room-list,.pgb-coverage-grid,.pgb-signal-row,.pgb-review-grid,.pgb-faq-grid,.pgb-compare-grid{display:grid;grid-template-columns:1fr;gap:10px;margin-top:16px}',
      '.pgb-step-grid article,.pgb-room-list div,.pgb-coverage-grid article,.pgb-signal-row div,.pgb-review-grid article,.pgb-faq-grid details,.pgb-compare-grid article{border:1px solid #dbe7f5;border-radius:8px;background:#fff;padding:14px;box-shadow:0 8px 22px rgba(16,24,40,.04)}',
      '.pgb-step-grid strong,.pgb-room-list strong,.pgb-coverage-grid strong,.pgb-signal-row strong,.pgb-review-grid strong,.pgb-compare-grid strong{display:block;font-size:15px;line-height:1.25;color:#101828}',
      '.pgb-review-grid span{display:inline-flex;color:#0f55c8;font-size:12px;font-weight:900;margin-bottom:6px}',
      '.pgb-step-grid p,.pgb-room-list p,.pgb-coverage-grid p,.pgb-signal-row p,.pgb-review-grid p,.pgb-compare-grid p{margin-top:7px;font-size:14px}',
      '.pgb-faq-grid summary{cursor:pointer;font-weight:900;line-height:1.3}',
      '.pgb-faq-grid details p{margin-top:9px;font-size:14px}',
      '[data-pg-ab-experiment][data-pg-ab-variant-only][hidden]{display:none!important}',
      'html[data-pg-ab-variant="B"] rte-formatter.text-block[class*="__text_aEtTtq"],html[data-pg-ab-variant="B"] .text-block[class*="__text_aEtTtq"],html[data-pg-ab-variant="B2"] rte-formatter.text-block[class*="__text_aEtTtq"],html[data-pg-ab-variant="B2"] .text-block[class*="__text_aEtTtq"]{display:none!important}',
      '@media(min-width:750px){.pgb-desc-band{grid-template-columns:minmax(0,1fr) minmax(320px,.72fr);align-items:center;gap:28px}.pgb-problem,.pgb-compare{grid-template-columns:1fr}.pgb-problem .pgb-copy,.pgb-compare .pgb-copy{max-width:980px}.pgb-step-grid,.pgb-room-list,.pgb-coverage-grid,.pgb-signal-row,.pgb-review-grid,.pgb-compare-grid{grid-template-columns:repeat(3,minmax(0,1fr))}}',
      '@media(max-width:749px){.pgb-gallery-strip{gap:6px}.pgb-copy h2{font-size:27px}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function bGalleryHtml() {
    var main = assetUrl('01-main-offer-direct-image2.png');
    var room = assetUrl('02-room-plan-direct-image2.png');
    var tech = assetUrl('03-trust-guarantee-direct-image2.png');
    var proof = assetUrl('04-review-proof-direct-image2.png');
    return [
      '<div class="pgb-product-gallery pgb-js-fallback" data-pg-b2="purchase-first-gallery" aria-label="PestGuard bed bug offer media">',
      '<div class="pgb-gallery-main"><img src="' + main + '" alt="PestGuard Buy 3 Get 3 Free bed bug room coverage plan" loading="eager"></div>',
      '<div class="pgb-gallery-strip">',
      '<img src="' + main + '" alt="PestGuard Buy 3 Get 3 Free offer image" loading="eager">',
      '<img src="' + room + '" alt="PestGuard bedroom kitchen storage room coverage plan" loading="lazy">',
      '<img src="' + tech + '" alt="PestGuard Dual-Wave ultrasonic technology image" loading="lazy">',
      '<img src="' + proof + '" alt="PestGuard verified buyer guarantee proof image" loading="lazy">',
      '</div></div>'
    ].join('');
  }

  function bPurchaseContextHtml() {
    return [
      '<div class="pgb-purchase-context pgb-js-fallback">',
      '<div class="pgb-score-row"><span>4.8 buyer rating</span><span>18,000+ homes</span><span>90-day guarantee</span></div>',
      '<div class="pgb-offer-box"><strong>Cover the rooms pests use to come back.</strong><span>For best results, place one PestGuard in each problem room or zone. Buy 3 Get 3 Free helps cover bedrooms, closets, kitchens, storage areas, and shared walls without sprays or trap cleanup.</span></div>',
      '</div>'
    ].join('');
  }

  function bDescriptionHtml() {
    var main = assetUrl('01-main-offer-direct-image2.png');
    var room = assetUrl('02-room-plan-direct-image2.png');
    var tech = assetUrl('03-trust-guarantee-direct-image2.png');
    var proof = assetUrl('04-review-proof-direct-image2.png');
    return [
      '<div class="pgb-desc pgb-js-fallback" data-pg-b2="proof-below-purchase">',
      '<section class="pgb-desc-band pgb-result"><div class="pgb-copy"><span class="pgb-kicker">Cleaner plug-in pest support</span><h2>Make your home feel protected without spraying chemicals around the rooms you live in.</h2><p>When pests keep coming back, the problem is often in the routes you cannot see: baseboards, outlets, closets, luggage areas, cabinets, and shared walls. PestGuard gives each room steady plug-in support without odor, residue, or daily trap cleanup.</p><div class="pgb-signal-row"><div><strong>18,000+ homes</strong><p>Chosen by families, renters, and hosts who want a simple room-by-room routine.</p></div><div><strong>90-day guarantee</strong><p>Try it in the rooms that worry you most. If it is not the right fit, the order is backed by a money-back guarantee.</p></div><div><strong>No spray routine</strong><p>No chemical smell, sticky traps, refill schedule, or visible cleanup around your living space.</p></div></div></div><div class="pgb-desc-media"><img src="' + main + '" alt="PestGuard Buy 3 Get 3 Free bed bug coverage plan" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-problem"><div class="pgb-copy"><span class="pgb-kicker">Why pests feel hard to stop</span><h2>What you see in the room is usually not the whole route.</h2><p>Bed bugs and household pests move through quiet spaces before they become obvious. A single spray or trap may handle what is visible, but bedrooms, baseboards, outlets, closets, luggage, and shared walls still need ongoing support.</p><div class="pgb-coverage-grid"><article><strong>Bedrooms feel urgent</strong><p>The room where you sleep is where pest activity feels most personal and stressful.</p></article><article><strong>Routes hide behind the room</strong><p>Walls, furniture, doors, and storage areas can split coverage from one outlet.</p></article><article><strong>Consistency matters</strong><p>Leave PestGuard running while you reduce clutter, seal gaps, and monitor active areas.</p></article></div></div></section>',
      '<section class="pgb-desc-band pgb-mechanism"><div class="pgb-copy"><span class="pgb-kicker">Dual-Wave ultrasonic support</span><h2>Plug it in and keep steady pressure on common hiding routes.</h2><p>PestGuard sends ultrasonic pulses through the room to help make covered areas less comfortable for pests over time. It is clean, odorless, and designed to run day and night in the rooms you want protected.</p><div class="pgb-step-grid"><article><strong>1. Plug into an open outlet</strong><p>Place one device in each room or zone where you want support.</p></article><article><strong>2. Leave it running 24/7</strong><p>No spray smell, poison residue, sticky trap cleanup, or refill schedule.</p></article><article><strong>3. Give the room time</strong><p>Use consistently with basic prevention: reduce clutter, seal gaps, wash bedding, and keep food sealed.</p></article></div></div><div class="pgb-desc-media"><img src="' + tech + '" alt="PestGuard Dual-Wave ultrasonic technology image" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-coverage"><div class="pgb-copy"><span class="pgb-kicker">Build coverage by room</span><h2>One device supports one zone. Six devices cover the places pests use most.</h2><p>Most homes need more than one outlet covered. The Buy 3 Get 3 Free bundle helps you protect the bedroom first, then the nearby routes pests use to move, hide, and return.</p><div class="pgb-room-list"><div><strong>Bedroom and sleeping areas</strong><p>Support mattresses, bed frames, nightstands, outlets, and wall routes around the room.</p></div><div><strong>Kitchen and pantry</strong><p>Cover cabinets, baseboards, food-storage areas, and shared walls where pests travel.</p></div><div><strong>Closets and storage</strong><p>Add support near luggage, laundry, boxes, basements, garages, and seasonal storage.</p></div></div></div><div class="pgb-desc-media"><img src="' + room + '" alt="PestGuard room coverage plan image" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-proof"><div class="pgb-copy"><span class="pgb-kicker">Why people choose PestGuard</span><h2>A simple routine that feels cleaner than sprays and traps.</h2><div class="pgb-review-grid"><article><span>Easy setup</span><strong>Plug in and leave it on</strong><p>Place one device in each target room, keep the outlet open, and let it run in the background.</p></article><article><span>Cleaner home routine</span><strong>No spraying around beds or food areas</strong><p>Useful for people who do not want chemical smell, residue, or visible trap cleanup in daily living spaces.</p></article><article><span>Bundle logic</span><strong>Cover more than one problem area</strong><p>Use the 6-pack to support bedrooms, closets, kitchen routes, storage, and shared walls at the same time.</p></article></div></div><div class="pgb-desc-media"><img src="' + proof + '" alt="PestGuard verified buyer guarantee proof image" loading="lazy"></div></section>',
      '<section class="pgb-desc-band pgb-compare"><div class="pgb-copy"><span class="pgb-kicker">A cleaner everyday routine</span><h2>Before you spray again, cover the routes pests use to return.</h2><div class="pgb-compare-grid"><article><strong>Sprays</strong><p>Can leave odor or residue around bedding, furniture, food areas, and pet spaces.</p></article><article><strong>Traps</strong><p>Only handle pests that reach the trap, and cleanup can make the problem feel worse.</p></article><article><strong>PestGuard</strong><p>Runs continuously in target rooms without chemicals, refills, or visible trap cleanup.</p></article></div></div></section>',
      '<section class="pgb-desc-band"><div class="pgb-copy"><span class="pgb-kicker">Before you choose your bundle</span><h2>Clear answers before you plug it in.</h2><div class="pgb-faq-grid"><details open><summary>How many devices should I use?</summary><p>Use one PestGuard per target room or zone. Walls, doors, and furniture reduce practical coverage, so multi-room homes usually need more than one device.</p></details><details><summary>How should I use it for best results?</summary><p>Keep it plugged in 24/7 and pair it with basic prevention: reduce clutter, seal gaps, wash bedding, store food tightly, and monitor active areas.</p></details><details><summary>What if it is not right for my home?</summary><p>Your order is backed by a 90-day money-back guarantee, so you can try the setup with less risk.</p></details></div></div><div class="pgb-desc-media"><img src="' + tech + '" alt="PestGuard guarantee and Dual-Wave trust image" loading="lazy"></div></section>',
      '</div>'
    ].join('');
  }

  function installBPageFallback(hit) {
    if (hit.experiment_id === BEDBUG_GOOGLE_PLUGIN_EXPERIMENT_ID) {
      if (hit.variant === 'B') installBedBugGooglePluginStyle(hit);
      return;
    }
    if (hit.experiment_id === BEDBUG_DESC_EXPERIMENT_ID) {
      if (hit.variant === 'B') installBedBugDescriptionOnly(hit);
      return;
    }
    if (hit.variant !== 'B2') return;
    ensureBPageFallbackStyles();
    hideOriginalDescriptionForB();
    var media = document.querySelector('.product-information__media');
    var productInfo = document.querySelector('.product-information');
    if (media) {
      var existingGallery = media.querySelector('.pgb-product-gallery');
      if (existingGallery && existingGallery.getAttribute('data-pg-b2') !== 'purchase-first-gallery') {
        existingGallery.outerHTML = bGalleryHtml();
      } else if (!existingGallery) {
        Array.prototype.forEach.call(media.children, function (node) {
          node.hidden = true;
          node.setAttribute('data-pg-ab-fallback-hidden', 'true');
        });
        media.insertAdjacentHTML('afterbegin', bGalleryHtml());
      }
    }
    if (!document.querySelector('.pgb-purchase-context')) {
      var picker = document.querySelector('#pg-variant-picker') || document.querySelector('variant-picker');
      if (picker) picker.insertAdjacentHTML('beforebegin', bPurchaseContextHtml());
    }
    var existingDesc = document.querySelector('.pgb-desc[data-pg-b2], .pgb-desc:not([data-pg-ab-variant-only])');
    if (existingDesc && existingDesc.getAttribute('data-pg-b2') !== 'proof-below-purchase') {
      existingDesc.outerHTML = bDescriptionHtml();
    } else if (!existingDesc && productInfo) {
      productInfo.insertAdjacentHTML('afterend', bDescriptionHtml());
    }
  }

  function ensureCVariantAnchor(hit) {
    var productInfo = document.querySelector('.product-information');
    var anchor = document.querySelector('[data-pg-c-anchor="' + hit.experiment_id + '"]');
    if (!anchor) {
      anchor = document.createElement('div');
      anchor.setAttribute('data-pg-c-anchor', hit.experiment_id);
      if (productInfo) {
        productInfo.insertAdjacentElement('afterend', anchor);
      } else {
        document.body.appendChild(anchor);
      }
    }
    return anchor;
  }

  function preserveNativeProductLayoutForC(hit) {
    if (!isProduct4CStyleVariant(hit)) return;
    document.querySelectorAll('.product-information__media [data-pg-ab-experiment="' + hit.experiment_id + '"][data-pg-ab-variant-only="A"]').forEach(function (node) {
      node.hidden = false;
      node.setAttribute('data-pg-ab-c-native-media-visible', 'true');
      hydrateDeferredVariantImages(node);
    });
  }

  function ensureProductPurchaseAnchor() {
    var existing = document.getElementById('pg-product-form');
    if (existing) {
      existing.style.scrollMarginTop = '96px';
      return existing;
    }
    var target = document.querySelector('.product-information form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('#pg-variant-picker') ||
      document.querySelector('variant-picker') ||
      document.querySelector('.buy-buttons-block') ||
      document.querySelector('.product-information');
    if (!target) return null;
    target.id = 'pg-product-form';
    target.style.scrollMarginTop = '96px';
    return target;
  }

  function bindCVariantCtas() {
    if (window.__pgCVariantCtasBound) return;
    window.__pgCVariantCtasBound = true;
    document.addEventListener('click', function (event) {
      var link = closestMatch(event.target, '.pgb-c-cta, .pgb-mobile-sticky-cta a, a[href="#pg-product-form"]');
      if (!link) return;
      var target = ensureProductPurchaseAnchor();
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var button = target.querySelector('button[name="add"], .product-form__submit, .add-to-cart-button') ||
        document.querySelector('button[name="add"], .product-form__submit, .add-to-cart-button');
      if (button && typeof button.focus === 'function') {
        window.setTimeout(function () {
          button.focus({ preventScroll: true });
        }, 320);
      }
    }, true);
  }

  function prepareCVariantProductLayout(hit) {
    preserveNativeProductLayoutForC(hit);
    hideOriginalDescriptionForB();
    ensureProductPurchaseAnchor();
    bindCVariantCtas();
  }

  function startCVariantTimers() {
    if (window.__pgCVariantTimersStarted) return;
    if (!document.querySelector('[data-pgb-countdown], [data-pgb-stock]')) return;
    window.__pgCVariantTimersStarted = true;
    var stockKeyPrefix = 'pgb_c_stock_';
    var saleEndKey = 'pgb_c_sale_end_at';
    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function dateKey() {
      var d = new Date();
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }
    function tonightEnd() {
      var stored = sessionStorage.getItem(saleEndKey);
      if (stored && !Number.isNaN(Number(stored))) return Number(stored);
      var now = new Date();
      var end = new Date(now);
      end.setHours(23, 59, 59, 999);
      sessionStorage.setItem(saleEndKey, String(end.getTime()));
      return end.getTime();
    }
    var saleEndAt = tonightEnd();
    function formatTime(ms) {
      if (ms <= 0) return 'SALE ENDED';
      var h = Math.floor(ms / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      var s = Math.floor((ms % 60000) / 1000);
      return pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    function updateCountdown() {
      var text = formatTime(Math.max(0, saleEndAt - Date.now()));
      document.querySelectorAll('[data-pgb-countdown]').forEach(function (el) {
        el.textContent = text;
      });
    }
    function hashToStock(value) {
      var hash = 0;
      for (var i = 0; i < value.length; i += 1) {
        hash = ((hash << 5) - hash) + value.charCodeAt(i);
        hash |= 0;
      }
      return 7 + Math.abs(hash) % 12;
    }
    var stockKey = stockKeyPrefix + dateKey();
    var current = parseInt(sessionStorage.getItem(stockKey) || '', 10);
    if (!current || current < 3) current = hashToStock(dateKey());
    current = Math.max(3, Math.min(18, current));
    function renderStock(next, animate) {
      current = Math.max(3, next);
      sessionStorage.setItem(stockKey, String(current));
      document.querySelectorAll('[data-pgb-stock]').forEach(function (el) {
        if (el.textContent === String(current)) return;
        if (animate) el.classList.add('is-changing');
        window.setTimeout(function () {
          el.textContent = String(current);
          el.classList.remove('is-changing');
        }, animate ? 220 : 0);
      });
    }
    function scheduleDecrement(first) {
      var delay = first ? 30000 : (45000 + Math.floor(Math.random() * 75000));
      window.setTimeout(function () {
        if (current > 3) renderStock(current - 1, true);
        scheduleDecrement(false);
      }, delay);
    }
    updateCountdown();
    renderStock(current, false);
    window.setInterval(updateCountdown, 1000);
    scheduleDecrement(true);
  }

  function fetchCVariantContent(hit) {
    if (window.__pgCVariantFetchStarted) return;
    window.__pgCVariantFetchStarted = true;
    var url = new URL(window.location.href);
    url.search = '';
    url.searchParams.set('view', PRODUCT4_C_VIEW_SUFFIX);
    url.searchParams.set('pg_ab_variant', hit.variant);
    url.searchParams.set('_pg_c_fetch', String(Date.now()));
    fetch(url.toString(), { credentials: 'same-origin' }).then(function (response) {
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var style = Array.prototype.slice.call(doc.querySelectorAll('style')).find(function (node) {
        return node.textContent.indexOf('.pgb-sticky-sale') >= 0 && node.textContent.indexOf('.pgb-c-cta') >= 0;
      });
      if (style && !document.getElementById('pgb-c-variant-style')) {
        var styleNode = document.createElement('style');
        styleNode.id = 'pgb-c-variant-style';
        styleNode.textContent = style.textContent;
        document.head.appendChild(styleNode);
      }
      var fragments = Array.prototype.slice.call(doc.querySelectorAll('[data-pg-c-fragment][data-pg-ab-experiment="' + hit.experiment_id + '"][data-pg-ab-variant-only="' + hit.variant + '"]'));
      if (!fragments.length) return;
      prepareCVariantProductLayout(hit);
      var anchor = ensureCVariantAnchor(hit);
      fragments.forEach(function (node) {
        node.hidden = false;
        anchor.appendChild(node);
        hydrateDeferredVariantImages(node);
      });
      startCVariantTimers();
    }).catch(function () {});
  }

  function installCVariantContent(hit) {
    if (hit.experiment_id === BEDBUG_DESC_EXPERIMENT_ID || !isProduct4CStyleVariant(hit)) return;
    prepareCVariantProductLayout(hit);
    var fragments = Array.prototype.slice.call(document.querySelectorAll('[data-pg-c-fragment][data-pg-ab-experiment="' + hit.experiment_id + '"][data-pg-ab-variant-only="' + hit.variant + '"]'));
    if (!fragments.length) {
      fetchCVariantContent(hit);
      return;
    }
    var anchor = ensureCVariantAnchor(hit);
    fragments.forEach(function (node) {
      anchor.appendChild(node);
      node.hidden = false;
      hydrateDeferredVariantImages(node);
    });
    startCVariantTimers();
  }

  function queueBPageFallback(hit) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        installBPageFallback(hit);
        installCVariantContent(hit);
      }, { once: true });
    } else {
      installBPageFallback(hit);
      installCVariantContent(hit);
    }
  }

  function addFormProperties(hit) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      [
        ['properties[_pg_ab_test]', hit.experiment_id],
        ['properties[_pg_ab_variant]', hit.variant],
        ['properties[_pg_ab_assignment]', hit.assignment_id]
      ].forEach(function (pair) {
        var input = form.querySelector('input[name="' + pair[0] + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = pair[0];
          form.appendChild(input);
        }
        input.value = pair[1];
      });
    });
  }

  function updateCartAttributes(hit) {
    var marker = 'pg_ab_cart_' + hit.experiment_id + '_' + hit.variant;
    if (sessionStorage.getItem(marker)) return;
    sessionStorage.setItem(marker, '1');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          pg_ab_test: hit.experiment_id,
          pg_ab_variant: hit.variant,
          pg_ab_assignment: hit.assignment_id,
          pg_ab_assigned_at: hit.assigned_at
        }
      })
    }).catch(function () {});
  }

  function sendEvent(hit, eventName, extra, dedupeKey) {
    if (dedupeKey && sessionStorage.getItem(dedupeKey)) return null;
    var payload = Object.assign({
      event_name: eventName,
      page_path: window.location.pathname,
      page_url: window.location.href,
      referrer: document.referrer || '',
      screen_width: window.innerWidth || 0
    }, hit, utmPayload(), extra || {});
    if (dedupeKey) sessionStorage.setItem(dedupeKey, '1');
    if (endpoint) {
      var body = JSON.stringify(payload);
      if (window.fetch) {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          body: body,
          keepalive: true
        }).catch(function () {
          if (navigator.sendBeacon) {
            navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
          }
        });
      } else if (navigator.sendBeacon) {
        navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      }
    }
    window.dispatchEvent(new CustomEvent('pg_abtest_event', { detail: payload }));
    return payload;
  }

  function trackSession(hit) {
    var key = 'pg_ab_session_' + hit.experiment_id;
    var payload = sendEvent(hit, 'session_assigned', {}, key);
    if (payload) window.dispatchEvent(new CustomEvent('pg_abtest_assigned', { detail: payload }));
  }

  function variantRoutePath(experiment, variant) {
    var routes = experiment.variant_routes && typeof experiment.variant_routes === 'object'
      ? experiment.variant_routes
      : {};
    var configured = routes[variant] || '';
    if (!configured && experiment.id === PRODUCT4_EXPERIMENT_ID && variant === 'C2') {
      configured = experiment.c2_redirect_path || '';
    }
    return configured ? normalizePath(configured) : '';
  }

  function isAdvertorialPdpStage(hit, experiment) {
    if (!hit || !experiment) return false;
    var stage = new URLSearchParams(window.location.search).get('pg_ab_stage') || '';
    return stage === 'pdp' && normalizePath(window.location.pathname) === variantRoutePath(experiment, 'A');
  }

  function redirectVariantRouteIfNeeded(hit, experiment) {
    if (!hit || !experiment) return false;
    var currentPath = normalizePath(window.location.pathname);
    if (isAdvertorialPdpStage(hit, experiment)) return false;
    var targetPath = variantRoutePath(experiment, hit.variant);
    if (!targetPath || currentPath === targetPath) return false;
    trackSession(hit);
    var url = new URL(window.location.href);
    url.pathname = targetPath;
    url.searchParams.set('pg_ab_experiment', hit.experiment_id);
    url.searchParams.set('pg_ab_variant', hit.variant);
    window.location.replace(url.toString());
    return true;
  }

  function closestMatch(node, selector) {
    var current = node;
    while (current) {
      if (current.nodeType !== 1) {
        current = current.parentElement || current.parentNode || null;
        continue;
      }
      if (current.matches && current.matches(selector)) return current;
      current = current.parentElement || (current.getRootNode && current.getRootNode().host) || null;
    }
    return null;
  }

  function trackAddToCart(hit, source) {
    sendEvent(hit, 'add_to_cart', {
      event_source: source || 'product_form'
    }, 'pg_ab_add_to_cart_' + hit.experiment_id);
  }

  function trackReachedCheckout(hit, source) {
    sendEvent(hit, 'reached_checkout', {
      event_source: source || 'checkout_button'
    }, 'pg_ab_reached_checkout_' + hit.experiment_id);
  }

  function trackPdpAfterAdvertorial(hit, experiment) {
    if (!isAdvertorialPdpStage(hit, experiment)) return;
    sendEvent(hit, 'pdp_after_adv_view', {
      event_source: 'advertorial_cta',
      funnel_stage: 'pdp'
    }, 'pg_ab_pdp_after_adv_' + hit.experiment_id);
  }

  function installInteractionTracking(hit, experiment) {
    if (window.__pgAbInteractionTrackingInstalled) return;
    window.__pgAbInteractionTrackingInstalled = true;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (form.matches('form[action*="/cart/add"]')) {
        trackAddToCart(hit, 'cart_add_form_submit');
      }
      if (form.matches('form[action*="/checkout"]') || form.querySelector('[name="checkout"]')) {
        trackReachedCheckout(hit, 'checkout_form_submit');
      }
    }, true);

    document.addEventListener('click', function (event) {
      var target = event.target;
      var anchor = closestMatch(target, 'a[href]');
      var pdpPath = variantRoutePath(experiment, 'A');
      var advPath = variantRoutePath(experiment, 'B');
      if (anchor && pdpPath && advPath && normalizePath(window.location.pathname) === advPath) {
        var destination = new URL(anchor.getAttribute('href') || anchor.href, window.location.origin);
        if (normalizePath(destination.pathname) === pdpPath) {
          var matchingCtas = Array.prototype.slice.call(document.querySelectorAll('a[href]')).filter(function (item) {
            try { return normalizePath(new URL(item.getAttribute('href') || item.href, window.location.origin).pathname) === pdpPath; }
            catch (_) { return false; }
          });
          sendEvent(hit, 'adv_cta_click', {
            event_source: 'advertorial_product_link',
            funnel_stage: 'adv_to_pdp',
            cta_index: matchingCtas.indexOf(anchor),
            cta_text: String(anchor.innerText || anchor.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 160),
            cta_href: destination.pathname + destination.search
          }, 'pg_ab_adv_cta_' + hit.experiment_id);
          destination.searchParams.set('pg_ab_experiment', hit.experiment_id);
          destination.searchParams.set('pg_ab_variant', hit.variant);
          destination.searchParams.set('pg_ab_stage', 'pdp');
          anchor.setAttribute('href', destination.pathname + destination.search + destination.hash);
        }
      }
      var cartAddForm = closestMatch(target, 'form[action*="/cart/add"]');
      if (cartAddForm && closestMatch(target, 'button, input[type="submit"], [role="button"], .shopify-payment-button__button, shopify-accelerated-checkout')) {
        if (closestMatch(target, '.shopify-payment-button__button, shopify-accelerated-checkout')) {
          trackReachedCheckout(hit, 'dynamic_checkout_button');
        } else {
          trackAddToCart(hit, 'cart_add_button_click');
        }
      }

      if (closestMatch(target, 'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-shopify="payment-button"], [data-testid*="Checkout"]')) {
        trackReachedCheckout(hit, 'checkout_button_click');
      }
    }, true);
  }

  repairPluginDescriptionImages();

  var targetExperiment = matchingExperiment();
  var experiment = targetExperiment || savedExperiment();
  if (!experiment) return;
  var hit = assignment(experiment, { canCreate: Boolean(targetExperiment) });
  if (!hit) return;
  window.PG_ABTEST = hit;
  if (targetExperiment) {
    if (redirectVariantRouteIfNeeded(hit, targetExperiment)) return;
    applyVisibility(hit);
    queueBPageFallback(hit);
  }
  addFormProperties(hit);
  updateCartAttributes(hit);
  installInteractionTracking(hit, experiment);
  trackPdpAfterAdvertorial(hit, experiment);
  if (targetExperiment && !isAdvertorialPdpStage(hit, experiment)) trackSession(hit);
})();
